import React from 'react';
import {iconNamesContext} from './IconName';
import {sharedIconAssets} from './sharedIconsAssets';

export const IconsProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <iconNamesContext.Provider value={sharedIconAssets}>
      {children}
    </iconNamesContext.Provider>
  );
};
